export default __webpack_public_path__ + "static/vanuatu-c0218c59f3596d3f4643e3020616f225.jpg";